import { useEffect, useRef } from "react"

import { sortaballs8ColorsLevelStore } from "../sortaballs-8-colors/level-store"
import { sortaballs10ColorsLevelStore } from "../sortaballs-10-colors/level-store"

// The level stores persist the games' "current puzzle". A battle seeds one of
// them to the challenge index, so remember the player's previous position and
// restore it when the battle ends — the games keep their own state.
// (The stores expose no getter; their storage keys mirror level-store.ts.)
const BALL_SORT_LEVEL_KEY = "sortaballs-8-colors-current-puzzle-id"
const SORTABALLS_LEVEL_KEY = "sortaballs-10-colors-current-puzzle-id"

interface PreviousLevel {
  id: number
  kind: "sortaballs-8-colors" | "sortaballs-10-colors"
}

const readStoredLevel = (storageKey: string): number=> {
  const stored = localStorage.getItem(storageKey)
  return stored ? Number(stored) : 1
}

// Shared by the accept and create battle flows: snapshot the challenge game's
// pre-battle puzzle, restore it on battle end and on route unmount.
export function useRestoreLevel() {
  const previousRef = useRef<null | PreviousLevel>(null)

  const snapshot = (hardMode: boolean): void=> {
    previousRef.current = {
      id: readStoredLevel(hardMode ? SORTABALLS_LEVEL_KEY : BALL_SORT_LEVEL_KEY),
      kind: hardMode ? "sortaballs-10-colors" : "sortaballs-8-colors",
    }
  }

  const restore = (): void=> {
    const previous = previousRef.current
    previousRef.current = null
    if (previous === null) return
    if (previous.kind === "sortaballs-10-colors") {
      sortaballs10ColorsLevelStore.setLevel(previous.id)
    } else {
      sortaballs8ColorsLevelStore.setLevel(previous.id)
    }
  }

  // Leaving the challenges route mid-battle (e.g. via the sidebar) restores
  // the games' previous puzzle positions.
  useEffect(()=> restore, [])

  return { restore, snapshot }
}